// removed by extract-text-webpack-plugin
module.exports = {"container":"SearchBar-container","info":"SearchBar-info"};